module.exports = __webpack_public_path__ + "img/USTOREBG.a3bfa5bd.png";